const I = 11, T = 2;
export {
  T as BORDER_HORIZONTAL_WIDTH,
  I as MINIMUM_INPUT_WIDTH
};
